module.exports = __webpack_public_path__ + "media/buyAnother.abd9081e.mp3";